import {Message} from 'element-ui';

var Fly=require("flyio/dist/npm/fly")
var fly = new Fly
fly.config.baseURL = '//edu.tjllmf.com/frontend';
fly.config.withCredentials = true;


// 请求拦截器
fly.interceptors.request.use((request) => {
  // Loading.service({text: '加载中...'})

  // if (getApp().globalData.loginData){
  //   request.headers['session-key'] = getApp().globalData.loginData.session_key
  // }

  // request.headers['Content-Type'] = 'application/json';

  return request
})

// 响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use(
  async response => {
    // Loading.service().close();

    if (response.data.code === 500103) {
      // console.log('未登录：', response)

      // let ref = await api.tokenRenewal()
      // let req = await fly.request(response.request)

      return response.data;
    } else if (response.data.code === 400104) {
      return response.data;
    } else if (response.data.code === 200) {
      if (response.request.url === '/user/signUpCourse' || response.request.url === '/user/login' || response.request.url === '/user/resetPassword'){
        return response.data.code
      }else{
        return response.data.data
      }
    }else {
      Message.error(response.data.msg);
      if (response.request.url === '/user/signUpCourse' || response.request.url === '/user/login'){
        return response.data.code;
      }else{
        return response.data.msg;
      }
    }
  },

  err => {
    // 发生网络错误后会走到这里
    // mta.Event.stat('log', { 'message': '发生接口请求错误：' + JSON.stringify(err) })
    return Promise.resolve('发生接口请求错误', err)
  }
)

export default fly